import { render } from "./AllergensFilterPage.vue?vue&type=template&id=12ab83df&scoped=true"
import script from "./AllergensFilterPage.vue?vue&type=script&lang=js"
export * from "./AllergensFilterPage.vue?vue&type=script&lang=js"

import "./AllergensFilterPage.vue?vue&type=style&index=0&id=12ab83df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ab83df"]])

export default __exports__